import { render } from "./HistoryDetails.vue?vue&type=template&id=3efa0f85"
import script from "./HistoryDetails.vue?vue&type=script&lang=js"
export * from "./HistoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__